var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
        title: "检测项目审查",
        visible: _vm.dialogVisible,
        width: "540px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt15",
          attrs: { "label-width": _vm.labelWidth + "px" },
        },
        [
          _vm._l(_vm.config, function (item, idx) {
            return [
              item.type == "radio"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "cid" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(item.name) + "： "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择" + item.name,
                            size: "small",
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        },
                        _vm._l(item.data, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "textarea"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "cid" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(item.name) + "： "),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "input"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "cid" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(item.name) + "： "),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, size: "small", type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }